import { createUseStyles } from "react-jss"
import { EmploymentContract } from "../../redux/types"
import InfoCard from "../InfoCard"
import { Colors } from "../../constants/colors"
import { useTranslation } from "react-i18next"
import PayList from "./PayList"

interface Props {
    employmentContract: EmploymentContract
}

const EmploymentContractCard = ({employmentContract}: Props) => {
    const styles = useStyles()
    const {t} = useTranslation(['employees', 'common']);

    const employmentHasEnded = () => {
      if (employmentContract.endDateString) {
        return new Date(employmentContract.endDateString) < new Date()
      }
      return false
    }

    return (
      <div className={styles.infoCardContainer}>
        <InfoCard 
          title={`${t('employment', {ns: 'common'})}: ${employmentContract.startDateString} - ${employmentContract.endDateString ?? t('ongoing', {ns: 'common'})}`} 
          className={styles.infoCard}
          titleColor={employmentHasEnded() ? Colors.gray3 : Colors.euro_800}
          headerStyle={employmentHasEnded() ? {textDecorationLine: 'line-through', textDecorationStyle: 'solid'} : {}}
        >
          {employmentContract?.externalId &&
          <div className={styles.row}>
            <div className={styles.label}>{t('id', {ns: 'common'})}</div>
            <div>{employmentContract?.externalId}</div>
          </div>
          }
          {employmentContract?.reportId &&
          <div className={styles.row}>
            <div className={styles.label}>{t('reportId', {ns: 'employees'})}</div>
            <div>{employmentContract?.reportId}</div>
          </div>
          }
          {employmentContract?.description &&
          <div className={styles.row}>
            <div className={styles.label}>{t('description', {ns: 'common'})}</div>
            <div>{employmentContract.description}</div>
          </div>
          }
          {employmentContract?.position &&
          <div className={styles.row}>
            <div className={styles.label}>{t('position', {ns: 'employees'})}</div>
            <div>{employmentContract.position}</div>
          </div>
          }
          {employmentContract?.collectiveAgreement &&
          <div className={styles.row}>
            <div className={styles.label}>{t('collectiveAgreement', {ns: 'employees'})}</div>
            <div>{employmentContract.collectiveAgreement}</div>
          </div>
          }
          <PayList pays={employmentContract.pays} />
        </InfoCard>
      </div>
    ) 
}

export default EmploymentContractCard

const useStyles = createUseStyles({
  infoCard: {
    flex: 1
  },
  row: {
      flex: 1,
      marginBottom: 10,
    },
  label: {
      display: 'flex',
      flexDirection: 'row',
      columnGap: 10,
      textTransform: 'uppercase',
      fontSize: 13,
      color: Colors.gray3
  },
  infoCardContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    columnGap: 20
  },
})
